const filterByCategory = (arr, category) => {
  return arr.filter(function (data) {
    return data.category === category;
  });
};

const filterPost = (arr, title) => {
  return arr.filter(function (data) {
    return data.title === title.split("-").join(" ");
  });
};

export { filterPost };
export default filterByCategory;
